// Area calculation and formatting utilities for live measurement overlays
// All inputs in editor dots (50 dots = 1 meter) unless noted otherwise

import { DPM } from '@/constants/coordinates'

/** Convert dots to meters */
const dotsToMeters = (dots: number) => dots / DPM

/** Calculate rectangle area in m² from dimensions in dots */
export function calculateRectArea(widthDots: number, heightDots: number): number {
  return dotsToMeters(widthDots) * dotsToMeters(heightDots)
}

/** Calculate ellipse area in m² from bounding-box dimensions in dots */
export function calculateEllipseArea(widthDots: number, heightDots: number): number {
  const rx = dotsToMeters(widthDots) / 2
  const ry = dotsToMeters(heightDots) / 2
  return Math.PI * rx * ry
}

/** Calculate polygon area in m² from points in dots using the Shoelace formula */
export function calculatePolygonAreaFromPoints(points: Array<{ x: number; y: number }>): number {
  if (points.length < 3) return 0
  let sum = 0
  for (let i = 0; i < points.length; i++) {
    const a = points[i]
    const b = points[(i + 1) % points.length]
    sum += a.x * b.y - b.x * a.y
  }
  const areaDots = Math.abs(sum) / 2
  // Convert from dots² to m²
  return areaDots / (DPM * DPM)
}

/** Format area as "12.3 m²" */
export function formatArea(m2: number): string {
  if (m2 < 10) return `${m2.toFixed(1)} m\u00B2`
  return `${Math.round(m2)} m\u00B2`
}

/** Format length as "2.34 m" */
export function formatLength(m: number): string {
  return `${m.toFixed(2)} m`
}

/** Format dimensions as "3.50 × 2.10 m" */
export function formatDimensions(wM: number, hM: number): string {
  return `${wM.toFixed(2)} \u00D7 ${hM.toFixed(2)} m`
}
